export default "__VITE_ASSET__C4IZig7I__"